import { render } from "./markBlock.vue?vue&type=template&id=4c0b9716&lang=html"
import script from "./markBlock.vue?vue&type=script&lang=js"
export * from "./markBlock.vue?vue&type=script&lang=js"

import "./markBlock.vue?vue&type=style&index=0&id=4c0b9716&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__